import React from 'react';
import styled from 'styled-components';
import SmallDoughnut from '@/common/components/SmallDoughnut';
import { PILLAR_QUESTION_MAP } from '@/common/constants/pillars';
import { PillarData } from '../../../types/api';
import { H3, PageSection } from '@/common/styles/page';

const PillarCardContainer = styled.div<{ $selected?: boolean }>`
  background: #ffffff;
  border: 1px solid ${props => (props.$selected ? '#3b82f6' : '#e5e7eb')};
  border-radius: 1rem;
  box-shadow: ${props => (props.$selected ? '0 8px 20px rgba(59, 130, 246, 0.18)' : '0 1px 2px rgba(15, 23, 42, 0.08)')};
  transition: transform 0.18s cubic-bezier(.2, .9, .2, 1), box-shadow 0.2s ease, border-color 0.2s ease;
  cursor: ${props => (props.$selected ? 'default' : 'pointer')};
  width: 100%;

  &:hover {
    transform: ${props => (props.$selected ? 'none' : 'translate3d(0, -4px, 0)')};
    box-shadow: ${props => (props.$selected ? '0 8px 20px rgba(59, 130, 246, 0.18)' : '0 4px 12px rgba(15, 23, 42, 0.12)')};
  }
`;

const PillarCardTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  min-width: 0;
`;

const PillarCardLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex: 1 1 auto;
  min-width: 0;
`;

const PillarCardTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1 auto;
  min-width: 0;
`;

const QuestionText = styled.div`
  font-size: 0.8125rem;
  color: #6b7280;
  line-height: 1.4;
  min-width: 0;
`;


export const PillarCard: React.FC<{
  item: PillarData;
  onOpen?: (k: string) => void;
  showQuestion?: boolean;
  selected?: boolean;
}> = ({ item, onOpen, showQuestion = false, selected = false }) => {
  const interactive = typeof onOpen === 'function';
  const handleClick = () => {
    if (interactive) onOpen(item.key);
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!interactive) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onOpen(item.key);
    }
  };


  return (
    <PillarCardContainer
      {...(interactive ? { role: 'button', tabIndex: 0, onClick: handleClick, onKeyDown: handleKeyDown } : {})}
      aria-label={interactive ? `Open pillar ${item.name}` : undefined}
      $selected={selected}
    >
      <PageSection style={{ padding: '0.75rem 1rem', minWidth: 0 }}>
        <PillarCardTitleRow>
          <PillarCardLeft>
            <SmallDoughnut value={item.score} colorized size={44} />
            <PillarCardTitleBlock>
              <H3>{item.name}</H3>
              {showQuestion && PILLAR_QUESTION_MAP[item.name] ? (
                <QuestionText>
                  {PILLAR_QUESTION_MAP[item.name]}
                </QuestionText>
              ) : null}
            </PillarCardTitleBlock>
          </PillarCardLeft>
        </PillarCardTitleRow>
      </PageSection>
    </PillarCardContainer>
  );
};
